'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');

class Orders {
  constructor(credentials, request, sdkConfiguration, customerId) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager([customerId]);
  }

  byId(orderId) {
    this.paramsManager.addPathParam(orderId);
    this.orderId = orderId;
    return this;
  }

  get() {
    if (this.orderId) {
      this.requestManager.requestConfigurationManager.setApi('GetOrder');
    } else {
      this.requestManager.requestConfigurationManager.setApi('GetAllOrders');
    }
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  create(order) {
    this.requestManager.requestConfigurationManager.setApi('CreateOrder');
    this.paramsManager.addBodyParams(order);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  addOn(order) {
    this.requestManager.requestConfigurationManager.setApi('CreateAddOn');
    this.paramsManager.addBodyParams(order);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

}

module.exports = Orders;
